import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class IronMineBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.IRON_MINE;

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 1 furnace
			Array.from(super.suppliesTileIndexes).slice(0, 1),
		);
	}

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);
		let populationConsumption =
			(consumption.get(ResourceType.POPULATION_CONSUMPTION) as number) ||
			0;
		populationConsumption -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.hoisting_winch,
		);
		consumption.set(
			ResourceType.POPULATION_CONSUMPTION,
			populationConsumption,
		);

		return consumption;
	}
}

export default IronMineBuildingTileEntity;
